export default{
  label:'offset',
  isResponsive:true,
  prefix:'offset',
  isStepAsLabel:true,
  steps:[
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
  ]
}



// WEBPACK FOOTER //
// ./src/shell/schemas/grid/col-offset.js